import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { AuthMiddleware, HeaderTokenMiddleware } from '../middleware/';
import { useSelector, useDispatch } from 'react-redux';
import { SetLookUpData, SetJobsUrl as SetJobsUrlAction } from '../actions';
import { GlobalApiErrorHandler } from './helpers';
import { reqGetRetrieveCreateCandidateLookupData, reqGetJobUrl } from '../axios/api';

export const Layout = (props) => {

  const [tokenLoaded, setTokenLoaded] = useState(false);
  const dispatch = useDispatch();
  const LookUpData = useSelector(state => state.LookUpData);

  const callbackToken = () => {
    setTokenLoaded(true);
  }

  HeaderTokenMiddleware({ callbackToken: callbackToken });
  AuthMiddleware({ tokenLoaded: tokenLoaded });

  const getLookUpData = () => {
    reqGetRetrieveCreateCandidateLookupData()
      .then(res => {
        dispatch(SetLookUpData(res.data));
      })
      .catch(err => {
        console.log(err);
        GlobalApiErrorHandler({ errors: err.response.data.errors });
      });
  }

  useEffect(() => {
    if (tokenLoaded && !LookUpData) {
      getLookUpData();
    }
  }, [tokenLoaded, LookUpData]);

  const [jobsUrl, setJobsUrl] = useState("");

  useEffect(() => {
    reqGetJobUrl().then(res => {
      setJobsUrl(res.data.url);
      dispatch(SetJobsUrlAction(res.data.url));
    }).catch(err => {
      console.log(err);
    });
  }, []);

  return (
    <div className="career-layout">
      <NavMenu jobsUrl={jobsUrl} />
      <main className="career-content-band">
        <Container className="margin-to-nav career-main-container">
          {
            tokenLoaded && props.children
          }
        </Container>
      </main>
    </div>
  );
}
